<template>
  <v-form v-model="formStatus.valid">
    <v-row>
      <v-col cols="12">
        <v-text-field
          filled
          label="Location name"
          v-model="editedData.name"
          :rules="[rules.required]"
          required
        >
          <template v-slot:append>
            <span class="hint">* required</span>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { textFieldRules } from '@/common'

export default {
  props: {
    editedData: {
      type: Object,
      default: () => ({ name: '' }),
    },
    formStatus: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rules: textFieldRules,
    }
  },
}
</script>